module.exports = __webpack_public_path__ + "img/elementwidths_jak.a2914686.png";